import { render, staticRenderFns } from "./importacao-ofx.vue?vue&type=template&id=2acc0a81&"
import script from "./importacao-ofx.vue?vue&type=script&lang=js&"
export * from "./importacao-ofx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports